// extracted by mini-css-extract-plugin
export var Breadcrumbs = "breadcrumbs-module--Breadcrumbs--2482d";
export var Breadcrumbs___clear = "breadcrumbs-module--Breadcrumbs___clear--1fe60";
export var Breadcrumbs___narrow = "breadcrumbs-module--Breadcrumbs___narrow--8bd2f";
export var Breadcrumbs_current = "breadcrumbs-module--Breadcrumbs_current--5a441";
export var Breadcrumbs_node = "breadcrumbs-module--Breadcrumbs_node--65700";
export var Breadcrumbs_path = "breadcrumbs-module--Breadcrumbs_path--354b1";
export var slideIn = "breadcrumbs-module--slide-in--17974";
export var slideInFromRight = "breadcrumbs-module--slide-in-from-right--8fbd0";